import * as React from 'react';

export default function SelectableCreditCardListPlaceholder() {
  return (
    <div className="module" data-placeholder-rows>
      <ul className="actionable-rows">
        <li className="actionable-row actionable-row--placeholder">
          <div className="actionable-row__content"></div>
          <ul className="actionable-row__actions">
            <li className="actionable-row__action"></li>
          </ul>
        </li>
        <li className="actionable-row actionable-row--placeholder">
          <div className="actionable-row__content"></div>
          <ul className="actionable-row__actions">
            <li className="actionable-row__action"></li>
          </ul>
        </li>
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/selectable_credit_card_list_placeholder.tsx